import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
    Card,
    CardBody,
    CardFooter,
    Col,
    Container,
    Row,
    UncontrolledTooltip,
} from "reactstrap";
import { size } from "lodash";
import Breadcrumbs from "../../../components/Common/Breadcrumb";


import Nouserimage from "../../../assets/images/users/no_image.png";
import Spinners from "components/Common/Spinner";
import UserService from 'Api/Services/UserService';



const AssignDrugListOption = () => {

    //meta title
    document.title = "Drug Form | infuseone";
    const params = useParams();
    const imageUrl = `${process.env.REACT_APP_DRUG_IMAGE_API_URL}`;
    const [isLoading, setLoading] = useState(false);
    const [userDrugForm, setUsersDrugForm] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    

    const LoadUserDrugDetail = async () => {
        setLoading(true);
        try {
            const response = await UserService.ShowUserdrugDetailForm(params.id).json();
           
            if (response.status === true) {
                setUsersDrugForm(response.data);
                setLoading(false);
            } else {
                setLoading(false);
                setError(response.message);
                return;
            }
        } catch (error) {
            setError('Something went wrong');
            return;
        }
    };
    useEffect(() => {
        LoadUserDrugDetail();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="container-fluid">
                        <Breadcrumbs title="Dashboard" breadcrumbItem="Drug Form" />
                        {isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <>
                                <Row >

                                    <Col xl={12} sm={12} >
                                        <Card className="text-center" >
                                            <CardBody>
                                                {/* <div className="mb-4">
                                                    <img className="avatar-el" src={`${imageUrl}/${userDrugForm.image}`} alt={userDrugForm.title} />
                                                </div> */}
                                                <div className="mb-4 d-flex justify-content-between align-items-center">
                                                    <h5 className="h2 mb-2 mb-3">
                                                        {userDrugForm.name}
                                                    </h5>
                                                    <Link to="/assgined-user-drug-list" className='btn btn-secondary'>Go Back</Link>
                                                </div>

                                                <div className="embed-responsive embed-responsive-16by9 ratio ratio-16x9">
                                                    <iframe
                                                        title={userDrugForm.name}
                                                        className="embed-responsive-item"
                                                        src={userDrugForm.form_iframe}
                                                    />
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>

                                </Row>

                            </>
                        }
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AssignDrugListOption;